module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-8-1500x630.5cc4d678.jpg";